"use strict";

exports.__esModule = true;
exports.default = void 0;

var _media = _interopRequireDefault(require("./media"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "type": "object",
  "properties": {
    "sectionType": {
      "enum": ["media"]
    },
    "sectionLayout": {
      "type": "string",
      "enum": ["grid", "slideshow"],
      "enumNames": ["Grid", "Slideshow"],
      "default": "grid"
    },
    "media": _media.default
  }
};
exports.default = _default;
module.exports = exports.default;